import {
  Design,
  DesignIntent,
  GetColumn,
  LanguageCode
} from '../../../types';
import { getIntentLabels } from './get-intent-labels';

export type IntentLabelRow = (
  Partial<Record<LanguageCode, string>>
  & {
    Name: string;
  }
);

/** Create CSV from @see DesignIntent, but import CSV to @see IntentLabelRow for table to display. */
type IntentLabelColumn = (
  GetColumn<DesignIntent, unknown>
);

export function getIntentLabelColumns(serialized: Design): IntentLabelColumn[] {
  const { languages } = serialized;
  const intentLabels = getIntentLabels(serialized);

  return [
    {
      getter: 'name',
      label: 'Name'
    },
    ...languages.map(({ language }): IntentLabelColumn => {
      return {
        getter: (row) => {
          return intentLabels.get(row.name)?.[language] ?? '';
        },
        label: language
      };
    })
  ];
}
